var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSacola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8905 7.66667V3.5C4.8905 2.83696 5.15389 2.20107 5.62274 1.73223C6.09158 1.26339 6.72746 1 7.3905 1C8.05354 1 8.68943 1.26339 9.15827 1.73223C9.62711 2.20107 9.8905 2.83696 9.8905 3.5V7.66667M2.66638 5.16667H12.1155C12.3558 5.16664 12.5933 5.21857 12.8117 5.31892C13.03 5.41926 13.2241 5.56563 13.3806 5.748C13.5371 5.93037 13.6523 6.14443 13.7183 6.37549C13.7843 6.60655 13.7996 6.84915 13.763 7.08667L12.7172 13.88C12.6264 14.4704 12.3273 15.0087 11.8739 15.3976C11.4205 15.7865 10.8429 16.0002 10.2455 16H4.53554C3.93838 16 3.36094 15.7862 2.90774 15.3973C2.45453 15.0085 2.15548 14.4702 2.06471 13.88L1.01888 7.08667C0.982351 6.84915 0.997618 6.60655 1.06363 6.37549C1.12965 6.14443 1.24485 5.93037 1.40133 5.748C1.55782 5.56563 1.75189 5.41926 1.97025 5.31892C2.1886 5.21857 2.42607 5.16664 2.66638 5.16667Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacola);
export default __webpack_public_path__ + "static/media/sacola.28dd46c5f78e65e1514e28ec7b1c7cd6.svg";
export { ForwardRef as ReactComponent };